export const URL = "https://netglobal-backend.herokuapp.com/"
